import { DestroyRef, Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { select, Store } from '@ngrx/store';
import { selectUser } from '@platform/platform.selectors';
import { ResourceStatuses } from '@platform/shared/resource.state';
import { RootState } from '@root/app.state';
import { filter, map, tap } from 'rxjs';

const ALLOWED_EMAILS = ['test@example.com', 'florian.gratwohl@obt.ch', 'jonas.mueller@obt.ch', 'max86work@gmail.com', 'myotest@obt.ch'];

@Directive({
  selector: '[appAdminsOnlyEmailBasedAuthorize]',
  standalone: true,
})
export class EmailBasedAuthorizeDirective implements OnInit {
  constructor(
    private store$: Store<RootState>,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    const user$ = this.store$.pipe(
      select(selectUser),
      filter((rs) => rs.status === ResourceStatuses.SUCCEEDED && rs.data !== null),
      map((rs) => rs.data.mail.toLowerCase()),
      tap((mail) => console.log({ mail })),
    );
    const isAdminEmail$ = user$.pipe(
      filter((email) => {
        return ALLOWED_EMAILS.includes(email);
      }),
      takeUntilDestroyed(this.destroyRef),
    );
    isAdminEmail$.subscribe((allowed) => {
      if (allowed) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
